import { MessagesStatus } from 'app/models/messages';
import { HttpErrorResponse } from '@angular/common/http';
import Swal from "sweetalert2";
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { EmpresasService } from 'app/services/empresas/empresas.service';
import { RiesgoService } from 'app/services/riesgo/riesgo.service';

@Component({
  selector: 'app-asignar-sector',
  templateUrl: './asignar-sector.component.html',
  styleUrls: ['./asignar-sector.component.scss'],
  providers: [MessagesStatus]
})
export class AsignarSectorComponent implements OnInit {
  editar: boolean;
  formularioSector: FormGroup;
  loading : boolean;
  sectores : any=[];
  @Input() idSector : string;
  @Output() cerrarAgregarSector: EventEmitter<boolean> = new EventEmitter();
  @Output() refresh: EventEmitter<boolean> = new EventEmitter();

  user : any;

  nombreEmpresa : any;
  constructor(private empresaService:EmpresasService, private riesgoService:RiesgoService,private msgStatus:MessagesStatus) { 

    this.user = JSON.parse(sessionStorage.getItem('UserActive'));

    this.formularioSector = new FormGroup({
      "idEmpresa" :new FormControl(this.empresaService.datosEmpresaSector.idEmpresa),
      "idSector" :new FormControl("",Validators.required),
      "Usuario":new FormControl(this.user.Usuario),
    });
    
  }

  ngOnInit() {
    this.lstcboSectores()
    this.nombreEmpresa = this.empresaService.datosEmpresaSector.Razon_Social;
  }

  CerrarPopUp(){
    this.cerrarAgregarSector.emit();
  }

  lstcboSectores(){
  this.riesgoService.obtenerSectoresEconomicos().subscribe(
  res=>{
      this.sectores = res;
  }
)
  }

  asignarSector(){

    Swal.fire({
      title: 'Espere',
      text:'Guardando información',
      type:'info',
      allowOutsideClick:false,
      heightAuto: false
      });
      Swal.showLoading();
      this.riesgoService.asignarSectorEmpresa(this.formularioSector.getRawValue())
      .subscribe(resp => {
      
      Swal.fire({
        title: "¡Éxito!",
        text: "Sector asignado correctamente",
        type: "success",
        allowOutsideClick: false,
        heightAuto: false
      }).then(res =>{
      
        if (res.value == true ){
          this.cerrarAgregarSector.emit();
          this.refresh.emit();         
        }
      
      });
      },(err: HttpErrorResponse)=> {
      this.loading = false;
      if (err.error instanceof ErrorEvent) {
        console.error("Error Event");
      } else {
        this.msgStatus.getMessage(err.status);            
      }
      Swal.fire({
        title: "ERROR",
        text: "SECTOR NO ASIGNADO. "+this.msgStatus.message ,
        type: "error",
        allowOutsideClick: true,
        heightAuto: false
      })
      });
  }

}
